﻿import MuiTextField from '@mui/material/TextField';
import withDefaultProps from '../withDefaultProps';

export const TextField = withDefaultProps(MuiTextField, { variant: 'filled' });
export default TextField;
